import $ from 'jquery'

export default navPlumScrollable

/** @ngInject */
function navPlumScrollable($timeout, $rootScope, DeviceChecker) {
    return ({
        restrict: 'A',
        scope: {
            isCollapsed: '=',
        },
        link(scope, element) {
            return $timeout(() => {
                const $window = $(window)
                const $navbarDashboard = element.find('.navbar-dashboard')

                const activate = function () {
          // Execute on directive load
                    let hasChangedState = $rootScope.previousState !== $rootScope.currentState
                    if (hasChangedState && !DeviceChecker.isMobile()) {
                        $timeout(
              () => {
                  const navbarDashboardOffsetBottom = $navbarDashboard.offset().top + $navbarDashboard.height()
                  return $('html, body').animate({ scrollTop: navbarDashboardOffsetBottom }, '500', 'swing')
              },
              1000
            )
                    }

          // Execute on state transition
                    return scope.$on('$stateChangeSuccess', (event, to, toParams, from) => {
                        hasChangedState = from.url !== to.url
                        if (hasChangedState && !DeviceChecker.isMobile()) {
                            const navbarDashboardOffsetBottom = $navbarDashboard.offset().top + $navbarDashboard.height()
                            return $window.scrollTop(navbarDashboardOffsetBottom)
                        }
                    })
                }

                return activate()
            })
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/navbar/navPlumScrollable.js